import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {of, from, tap} from 'rxjs';
import { switchMap, map, catchError, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import {AppState} from "../../../shared/state/app.state";

import {
  getAllUsers,
  getAllUsersFailure,
  getAllUsersSuccess, getTenantsListOfUserRoles, getTenantsListOfUserRolesFailure, getTenantsListOfUserRolesSuccess,
  updateUsersCustomerId,
  updateUsersCustomerIdFailure,
  updateUsersCustomerIdSuccess,
  updateUsersRoleId, updateUsersRoleIdFailure,
  updateUsersRoleIdSuccess,
} from "./graph-user.action";
import {InternalUserService} from "../../data-access/internal-user.service";

@Injectable()
export class GraphUserEffects {

  getAllUsers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getAllUsers),
      switchMap(() =>
        this.adminService.getUsers()
          .pipe(
            map((users) => getAllUsersSuccess({users: users})),
            catchError((error) => of(getAllUsersFailure({ error })))
          )
      )
    )
  );

  getTenantsListOfUserRoles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getTenantsListOfUserRoles),
      switchMap(() =>
        this.adminService.getTenantsListOfUserRoles()
          .pipe(
            map((roles) => getTenantsListOfUserRolesSuccess({tenantRoles: roles})),
            catchError((error) => of(getTenantsListOfUserRolesFailure({ error })))
          )
      )
    )
  );

  updateUserCustomerId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateUsersCustomerId),
      switchMap((action) =>
        this.adminService.updateUserCustomerId(action.userId, action.newCustomerId)
          .pipe(
            map((users) => updateUsersCustomerIdSuccess({users: users})),
            catchError((error) => of(updateUsersCustomerIdFailure({ error })))
          )
      )
    )
  );

  updateUsersRoleId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateUsersRoleId),
      switchMap((action) =>
        this.adminService.updateUserRoles(action.userId, action.roleId)
          .pipe(
            map((users) => updateUsersRoleIdSuccess({users: users})),
            catchError((error) => of(updateUsersRoleIdFailure({ error })))
          )
      )
    )
  );



  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private adminService: InternalUserService
  ) {}
}
